import { UserWalletOperationTypeEnum } from 'app/models';

export class UserWalletOperationTypeModel {
    public static UserWalletOperationTypeList: Array<any> = [
        { name: 'All', value: null },
        { name: 'Transfer from Driver Wallet', value: UserWalletOperationTypeEnum.RiderTransferFromXpressWallet },
        { name: 'Regular', value: UserWalletOperationTypeEnum.CustomerPayment },
        { name: 'Job earning', value: UserWalletOperationTypeEnum.RiderEarning },
        { name: 'Cash in to Wallet', value: UserWalletOperationTypeEnum.TopUpWallet },
        { name: 'Cash-out', value: UserWalletOperationTypeEnum.PayOut },
        { name: 'Commission', value: UserWalletOperationTypeEnum.RiderCommission },
        { name: 'Tip to Driver', value: UserWalletOperationTypeEnum.CustomerTip },
        { name: 'Digital Platform Fee', value: UserWalletOperationTypeEnum.DailyServiceFee },
        { name: 'Cash-out Pending', value: UserWalletOperationTypeEnum.PayOutPending },
        { name: 'Cash-out Fee', value: UserWalletOperationTypeEnum.PayOutFee },
        { name: 'Refund from Xpress', value: UserWalletOperationTypeEnum.Refund },
        { name: 'Cash Out Restore', value: UserWalletOperationTypeEnum.PayOutRestore },
        { name: 'Cancellation fee', value: UserWalletOperationTypeEnum.CancellationFee },
        { name: 'Waiting fee', value: UserWalletOperationTypeEnum.WaitingFee },
        { name: 'Cash Out Fee Restore', value: UserWalletOperationTypeEnum.PayOutFeeRestore },
        { name: 'Waiting earning', value: UserWalletOperationTypeEnum.WaitingFeeRiderEarning },
        { name: 'Customer Cancellation', value: UserWalletOperationTypeEnum.CancellationFeeRiderEarning },
        { name: 'Withholding Tax', value: UserWalletOperationTypeEnum.WithholdingTax },
        { name: 'Referral Bonus', value: UserWalletOperationTypeEnum.ReferralEarning },
        { name: 'Prize Money', value: UserWalletOperationTypeEnum.PrizeMoney },
        { name: 'Service fee', value: UserWalletOperationTypeEnum.RiderServiceFee },
        { name: 'Cash Rider Earning', value: UserWalletOperationTypeEnum.CashRiderEarning },
        { name: 'Tip', value: UserWalletOperationTypeEnum.RiderTip },
        { name: 'Xpress Incentive', value: UserWalletOperationTypeEnum.XpressIncentive },
        { name: 'Transfer to Cash Wallet', value: UserWalletOperationTypeEnum.RiderTransferToCashWallet },
        { name: 'Pay Out', value: UserWalletOperationTypeEnum.PayOutToPaymentCard },
        { name: 'Top Up', value: UserWalletOperationTypeEnum.TopUpFromPaymentCard }
    ];
}
